import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const TopTenReviews: Site = {
  id: 'toptenreviews',
  logo: 'svg/toptenreviews.svg',
  label: 'Top Ten Reviews',
  analyticsName: 'toptenreviews',
  hostname: 'toptenreviews.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
